import { feedUserSelector, feedPostSelector, isFeedUserMemberSelector } from 'selectors/feedSelectors'
import { connectOptionally, OptionalRendererProps, NO_RENDER, createPositiveRendererProps } from 'tangle-shared'
import FeedPostHeader, {
  FeedPostHeaderStateProps,
  FeedPostHeaderDispatchProps,
  FeedPostHeaderOwnProps,
} from 'components/features/socialFeed/FeedPost/FeedPostHeader'
import { MapDispatchToPropsFunction } from 'react-redux'
import { State } from 'interfaces/state'
import { isSocialInsightPost } from 'helpers/feedHelpers'

const mapStateToProps = (state: State, ownProps: FeedPostHeaderOwnProps): OptionalRendererProps<FeedPostHeaderStateProps> => {
  const user = feedUserSelector(state, ownProps)
  const post = feedPostSelector(state, ownProps)

  if (!user || !post || isSocialInsightPost(post)) {
    return NO_RENDER()
  }

  const isOwn = isFeedUserMemberSelector(state, ownProps)

  return createPositiveRendererProps({
    isOwn: !!isOwn,
    isEdited: post.is_edited,
    created: post.created,
    matchingPeergroup: post.peergroup,
  })
}

const mapDispatchToProps: MapDispatchToPropsFunction<FeedPostHeaderDispatchProps> = () => ({})

const FeedPostHeaderContainer = connectOptionally<
  FeedPostHeaderStateProps, FeedPostHeaderDispatchProps, FeedPostHeaderOwnProps
>(mapStateToProps, mapDispatchToProps)(FeedPostHeader)

export default FeedPostHeaderContainer
